// extracted by mini-css-extract-plugin
module.exports = {"container":"group_container__GQJxd","reducedHero":"group_reducedHero__z5bXB"};